import type {CreatePaymentMethodP24Data} from '@stripe/stripe-js';
import {onCheckoutUpdate} from '../checkout';
import {AbstractStripePayment, type ConfirmResult, type TokenResult} from './abstract/class-abstract-stripe-payment';
import {billingDetails} from './stripe';
import {type Stripe, type StripeElements, type StripeP24BankElement} from '@stripe/stripe-js';
import {type PeachPayCheckoutData} from '../types';

declare const peachpay_checkout_data: PeachPayCheckoutData;

class StripeP24Payment extends AbstractStripePayment {
	private readonly $p24Element: StripeP24BankElement;

	constructor(stripe: Stripe, elements: StripeElements) {
		super(stripe, elements);

		this.$p24Element = elements.create('p24Bank', {});
		onCheckoutUpdate(() => {
			try {
				this.$p24Element.mount('#pp-p24-element');
			} catch {
				// Do no harm
			}
		});
		try {
			this.$p24Element.mount('#pp-p24-element');
		} catch {
			// Do no harm
		}
	}

	public gatewayId() {
		return 'peachpay_stripe_p24';
	}

	public async tokenize(): Promise<TokenResult> {
		const billing_details = billingDetails();

		if (peachpay_checkout_data.page.is_order_pay && peachpay_checkout_data.order_pay_details) {
			billing_details.name = peachpay_checkout_data.order_pay_details.billing_first_name + ' ' + peachpay_checkout_data.order_pay_details.billing_last_name;
			billing_details.email = peachpay_checkout_data.order_pay_details.billing_email;
		}

		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			type: 'p24',
			p24: this.$p24Element,
			billing_details,
		} as CreatePaymentMethodP24Data);

		if (error) {
			const message = error.message ?? 'Failed to tokenize payment method.';

			return [null, {
				paymentStatus: 'creationfailed',
				note: message,
			}];
		}

		if (!paymentMethod?.id) {
			return [null, {
				paymentStatus: 'creationfailed',
				note: 'Failed to tokenize payment method.',
			}];
		}

		return [paymentMethod.id, {}];
	}

	public async confirm(clientSecret: string, intermediateURL?: string | undefined): Promise<ConfirmResult> {
		const {paymentIntent, error} = await this.stripe.confirmP24Payment(clientSecret, {return_url: intermediateURL});

		if (error) {
			const message = error.message ?? 'Failed to confirm payment.';
			return [null, {
				note: message,
			}];
		}

		if (paymentIntent) {
			return ['success', {}];
		}

		return [null, {}];
	}
}

export {
	StripeP24Payment,
};
